import axios from '@/libs/api.request'
import {getToken} from '@/libs/util'
import config from '@/config'

// const SvnFlowBaseUrl = 'http://127.0.0.1:8002/api/1.0/flow/svnflow/'
// 持续发布基础URL
const baseDeployUrl = config.baseDeployUrl
const SvnFlowBaseUrl = baseDeployUrl + '/api/1.0/flow/svnflow/'
const SvnUrl = baseDeployUrl + '/api/1.0/flow/svn/'

const baseHeaders = {
  'Authorization': 'OPS ' + getToken()
}

export const getList = (params) => {
  return axios.request({
    url: SvnFlowBaseUrl + 'list',
    headers: baseHeaders,
    params: params,
    method: 'get'
  })
}

export const saveSvnFlow = (data) => {
  return axios.request({
    url: SvnFlowBaseUrl + 'create',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const fetchChangeFileList = (data) => {
  return axios.request({
    url: SvnUrl + 'changefile/list',
    headers: baseHeaders,
    data: data,
    method: 'post'
  })
}

export const getSvnFlowDetail = (params) => {
  return axios.request({
    url: SvnFlowBaseUrl + params.id,
    headers: baseHeaders,
    method: 'get'
  })
}

export const mergeSvnFlow = (id) => {
  return axios.request({
    url: SvnFlowBaseUrl + id + '/merge_request',
    headers: baseHeaders,
    method: 'post'
  })
}

export const buildSvnFlow = (id, scene) => {
  return axios.request({
    url: SvnFlowBaseUrl + id + '/build/' + scene,
    headers: baseHeaders,
    params: {
      async: true
    },
    method: 'get'
  })
}

export const cancelSvnFlow = (id) => {
  return axios.request({
    url: SvnFlowBaseUrl + id,
    headers: baseHeaders,
    method: 'delete'
  })
}

// 取到可以回滚的svn版本列表
export const fetchRollbackVersionsList = (value) => {
  return axios.request({
    url: SvnFlowBaseUrl + value + '/rollback_version_lst',
    headers: baseHeaders,
    method: 'get'
  })
}

// svnflow 回滚
export const rollbackSvnFlow = (id, version) => {
  return axios.request({
    url: SvnFlowBaseUrl + id + '/rollback/' + version,
    headers: baseHeaders,
    method: 'get'
  })
}
